import { ChainId } from '@ui/types/chain';
import { getContract, PublicClient, WalletClient } from 'viem';

import LVMONRedeemer from '../abis/LVMONRedeemer';
import { getContractAddress } from '../constants/address';

export const getLVMONRedeemer = ({
  chainId,
  publicClient,
  walletClient,
}: {
  publicClient: PublicClient;
  walletClient?: WalletClient;
  chainId: ChainId;
}) => {
  const address = getContractAddress('LVMONRedeemer', chainId);
  if (!address) throw new Error('Contract address not found');

  return getContract({
    abi: LVMONRedeemer,
    address,
    client: {
      public: publicClient,
      wallet: walletClient,
    },
  });
};
